import React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

/**
 * QueryClient instance
 *
 * This creates and exports a new instance of QueryClient from TanStack Query.
 * The QueryClient is responsible for managing the cache, queries, and mutations
 * in the application. It's used as the client prop in the QueryClientProvider.
 *
 * By exporting it, we allow other parts of the application (like debug tools)
 * to access and interact with the same QueryClient instance.
 */
export const queryClient = new QueryClient();

/**
 * TanStackQueryProvider Component
 *
 * This component sets up the TanStack Query (React Query) provider for the application.
 * It wraps the children components with QueryClientProvider, providing them access
 * to the React Query functionality.
 *
 * @param props - The component props
 * @param props.children - The child components to be wrapped
 * @returns A React element wrapping the children with QueryClientProvider
 */
function TanStackQueryProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

export default TanStackQueryProvider;
